import React from 'react';
import { styled } from '@mui/material/styles';
import { Grid, Box, Typography, Link } from '@mui/material';

import logo from './assets/PEO_InformalLogo_Black.png';

const StyledRootBox = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    justifyContent: 'center',
  },
}));

const StyledFooterCopy = styled(Box)(({ theme }) => ({
  borderTopWidth: 1,
  borderTopStyle: 'solid',
  borderTopColor: theme.palette.background.emphasis,
}));

const StyledCopy = styled(Typography)(({ theme }) => ({
  color: theme.palette.secondary.contrastText,
  paddingLeft: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    marginLeft: 'auto',
    marginRight: 'auto',
    textAlight: 'right',
  },
}));

const StyledGrid = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.secondary.contrastText,
  alignItems: 'right',
  textAlign: 'right',
  justifyContent: 'right',
  paddingRight: theme.spacing(2),
}));

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        width: '100%',
        minHeight: 100,
        flexShrink: 0,
        backgroundColor: '#9C1555',
      }}
    >
      <Grid container>
        <StyledGrid item xs={12}>
          <StyledRootBox pt={1} pb={1}>
            <Link href="/" color="inherit" underline="none">
              <Box
                component="img"
                sx={{
                  height: 'auto',
                  width: 'auto',
                  paddingLeft: 2,
                  maxWidth: 75,
                }}
                alt="Logo."
                src={logo}
              />
            </Link>
          </StyledRootBox>
          <StyledFooterCopy pt={1} pb={2} alignItems="right">
            <StyledCopy
              color="textSecondary"
              component="p"
              variant="caption"
              gutterBottom={false}
            >
              {`© ${new Date().getFullYear()} PEO International. All rights reserved.`}
            </StyledCopy>
          </StyledFooterCopy>
        </StyledGrid>
      </Grid>
    </Box>
  );
}
